/** International Redirect Cookie */
function setCookie(name,value,days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

export default function() {
  var url_params = new URLSearchParams(window.location.search);
  var has_intl_bypass = url_params.get('intl-redirect') === '0';
  var intl_redirect_cookie = getCookie('INTL_REDIRECT');

  if (has_intl_bypass) {
    // Always set bypass cookie if query string is set
    setCookie('INTL_REDIRECT', '0'); // Session Cookie
  } else {
    // If no cookie is set yet
    if (intl_redirect_cookie === null)  {
      if (window.location.pathname === '/pow-international/') {
        // Entering site from the home page with .htaccess redirect
        setCookie('INTL_REDIRECT', '1');
      } else {
        // Entering the site from another URL
        setCookie('INTL_REDIRECT', '0');
      }
    }
  }

}
